import './type-of-modal-badge-2023.css'
const badgeOptions = {
    Reassign: {
        text: 'Reassign',
        backgroundColor: '#FFEDD5',
        textColor: '#F97316'
    },
    Old: {
        text: 'Old Student',
        backgroundColor: '#DBEAFE',
        textColor: '#3B82F6'
    }
}

const TypeOfModalBadge2023 = ({ todoDescription }) => {
    let key = todoDescription.split(' ')[0]
    if(!badgeOptions[key]) {
        return null
    } else {
        return (
            <div className="type-of-modal-badge-2023" style={{
                backgroundColor: badgeOptions[key].backgroundColor, 
                color: badgeOptions[key].textColor
            }}>{badgeOptions[key].text}</div>
        )
    }
}
export default TypeOfModalBadge2023